import React from "react";
import { GetLanguagesForIds } from "../../../api/batchNotificationController";
import { ILanguage } from "../../../common/interfaces";
import Shared from "../../../common/shared";
import BatchMessageLanguageDetailModel, {
	LanguageModel,
} from "../../../models/BatchMessage/BatchMessageLanguageDetailModel";
import { MessageDetail } from "../../../models/BatchMessage/BatchMessageSchedulingDetailModel";
import { MessageScheduleRow } from "../../BatchNotification/MessageScheduleRow/MessageScheduleRow";

export interface TemplateListDataGridAccordionProp {
	messageDetail: MessageDetail;
	getIsBatchMessageTypeSMS: boolean;
	getIsBatchMessageTypeWhatsApp: boolean;
	messageIndex: number;
	country: string;
}

export const TemplateListDataGridAccordion: React.FC<TemplateListDataGridAccordionProp> = ({
	messageDetail,
	getIsBatchMessageTypeSMS,
	getIsBatchMessageTypeWhatsApp,
	messageIndex,
	country,
}) => {
	const [languages, setLanguages] = React.useState<LanguageModel[]>();
	const [
		batchMessageLanguageDetail,
		setBatchMessageLanguageDetail,
	] = React.useState<BatchMessageLanguageDetailModel>(
		new BatchMessageLanguageDetailModel()
	);

	React.useEffect(() => {
		const getAllLanguages = async () => {
			try {
				const res = await GetLanguagesForIds(messageDetail.languageIds);
				if (res.error) {
					Shared.showSnackbarMessage(res.error);
				} else {
					setLanguages(res.responseObj ? res.responseObj : []);
					const tempBMLD = new BatchMessageLanguageDetailModel();
					if (res.responseObj) {
						tempBMLD.languages = res.responseObj;
					}
					setBatchMessageLanguageDetail(tempBMLD);
				}
			} catch (err) {
				Shared.showSnackbarMessage(err);
			}
		};
		getAllLanguages();
	}, [messageDetail]);

	const selectedLanguageList = (): ILanguage[] => {
		return Shared.getLanguageByCode(getLanguages());
	};

	const getLanguages = (): string[] => {
		if (languages) {
			if (languages.length > 0) {
				return languages
					.map((x: LanguageModel) => x.code)
					.filter(
						(value: any, index: number, self: any) =>
							self.indexOf(value) === index
					);
			}
		}
		return [];
	};

	return (
		<MessageScheduleRow
			key={messageIndex}
			country={country}
			messageIndex={messageIndex}
			messageDetail={messageDetail}
			selectedLanguageList={selectedLanguageList()}
			isReadOnly={true}
			getIsBatchMessageTypeSMS={getIsBatchMessageTypeSMS}
			getIsBatchMessageTypeWhatsApp={getIsBatchMessageTypeWhatsApp}
			highlightRequiredDetail={false}
			batchMessageLanguageDetail={batchMessageLanguageDetail}
			onMessageSelectionChange={() => {}}
			onLanguageChangeHandler={() => {}}
			onDateTimeValueChange={() => {}}
			onTimeZoneChange={() => {}}
			onRecurrenceDetailChange={() => {}}
		/>
	);
};
